/* MantoPro Theme JS — Sety Studio */
'use strict';

document.addEventListener('DOMContentLoaded', function () {
  initSlideshows();
  initMobileMenu();
  initFAQ();
  initFilters();
  initGallery();
  initQty();
  updateCartBadge();
});

/* ===== SLIDESHOW ===== */
function initSlideshows() {
  document.querySelectorAll('.slideshow').forEach(function (el) {
    var track = el.querySelector('.slideshow__track');
    var slides = el.querySelectorAll('.slideshow__slide');
    var dots = el.querySelectorAll('.slideshow__dot');
    var prev = el.querySelector('.slideshow__prev');
    var next = el.querySelector('.slideshow__next');
    if (!track || slides.length < 2) return;

    var cur = 0;
    var auto = el.dataset.auto !== 'false';
    var speed = parseInt(el.dataset.speed || 5000);
    var timer;

    function go(idx) {
      cur = ((idx % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
    }

    function reset() {
      clearInterval(timer);
      if (auto) timer = setInterval(function () { go(cur + 1); }, speed);
    }

    if (prev) prev.addEventListener('click', function () { go(cur - 1); reset(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); reset(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); reset(); }); });

    /* swipe */
    var tx = 0;
    el.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 48) { go(diff > 0 ? cur + 1 : cur - 1); reset(); }
    });

    go(0);
    if (auto && slides.length > 1) timer = setInterval(function () { go(cur + 1); }, speed);
  });
}

/* ===== MOBILE MENU ===== */
function initMobileMenu() {
  var btn = document.querySelector('.mobile-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (!btn || !nav) return;
  btn.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
  });
}

/* ===== FAQ ===== */
function initFAQ() {
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  });
}

/* ===== FILTROS ===== */
function initFilters() {
  /* toggle grupos */
  document.querySelectorAll('.filter-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      toggle.closest('.filter-group').classList.toggle('is-open');
    });
  });

  /* abre o primeiro */
  var first = document.querySelector('.filter-group');
  if (first) first.classList.add('is-open');

  /* botão mobile */
  var mBtn = document.querySelector('.mobile-filter-btn');
  var sidebar = document.querySelector('.collection-sidebar');
  if (mBtn && sidebar) {
    mBtn.addEventListener('click', function () { sidebar.classList.toggle('is-open'); });
  }

  /* submit ao mudar checkbox */
  document.querySelectorAll('.filter-form input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      cb.closest('form').submit();
    });
  });

  /* sort */
  var sort = document.querySelector('.sort-select');
  if (sort) {
    sort.addEventListener('change', function () { sort.closest('form').submit(); });
  }
}

/* ===== GALERIA PRODUTO ===== */
function initGallery() {
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var mainImg = document.querySelector('.gallery-main img');
  if (!mainImg) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      mainImg.src = thumb.querySelector('img').src;
      mainImg.srcset = thumb.querySelector('img').srcset || '';
    });
  });
}

/* ===== QUANTIDADE ===== */
function initQty() {
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('.qty-input');
    wrap.querySelector('[data-minus]').addEventListener('click', function () {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    wrap.querySelector('[data-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });
}

/* ===== VARIANTES ===== */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.size-btn');
  if (!btn) return;
  var form = btn.closest('[data-product-form]');
  if (!form) return;
  btn.closest('.size-btns').querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
  btn.classList.add('is-active');
  var hiddenId = form.querySelector('input[name="id"]');
  if (hiddenId && btn.dataset.vid) hiddenId.value = btn.dataset.vid;

  /* atualiza preços */
  var price = btn.dataset.price;
  var compare = btn.dataset.compare;
  var discount = btn.dataset.discount;
  if (price) {
    var pe = form.querySelector('.p-price');
    var ce = form.querySelector('.p-compare');
    var be = form.querySelector('.p-badge');
    if (pe) pe.textContent = price;
    if (ce) ce.textContent = compare || '';
    if (be) be.textContent = discount ? '-' + discount + '%' : '';
    if (ce) ce.style.display = compare ? 'inline' : 'none';
    if (be) be.style.display = discount ? 'inline' : 'none';
  }
});

/* ===== ADD TO CART ===== */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.classList.contains('product-form')) return;
  e.preventDefault();

  var btn = form.querySelector('.btn-cart');
  var orig = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adicionando…'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: form.querySelector('input[name="id"]').value, quantity: parseInt(form.querySelector('.qty-input').value || 1) })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btn) {
        btn.textContent = '✓ Adicionado!';
        btn.style.background = '#2ea842';
        updateCartBadge();
        setTimeout(function () { btn.disabled = false; btn.textContent = orig; btn.style.background = ''; }, 2200);
      }
    })
    .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
});

/* ===== BADGE DO CARRINHO ===== */
function updateCartBadge() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-badge').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    });
}
